import { createAction } from 'redux-act';
export const navigateTo = createAction<any>('Navigate To Route');
